/**
 * 评论的回复框 INPUT_TYPE.COMMENT  回复的评论框 INPUT_TYPE.REPLAY
 */
import React, {useState, useRef, useContext, useEffect} from 'react';

import IfRender from 'components/IfRender';
import { MAX_LENGTH } from 'pages/work/constants';
import { YDLog } from 'components/YDLog'
import {UserContext} from 'components/UserProvider';
import Emoji from 'components/Emoji';

import {REPLAY, ReplayPostParams} from 'fetch/works';
import redirectLogin from 'fetch/redirectLogin'
import { showToast } from '@turingshequ/react-toast/src';

import s from './index.module.scss';

export enum INPUT_TYPE {
  COMMENT,
  REPLAY
}
interface Props {
  type?: INPUT_TYPE
  commentId: number
  replyId?: number
  showInput?: boolean
  onCancel?: () => void
  onSuccess: (item: any, id?: number) => void
}
const ReplayInput: React.FC<Props> = ({
  type = INPUT_TYPE.COMMENT,
  commentId,
  replyId,
  onCancel,
  onSuccess,
  showInput = true
}) => {

  const { user } = useContext(UserContext)

  const input = useRef<HTMLTextAreaElement>(null);

  const [inputText, setInputText] = useState('');
  const [inputTextNum, setInputTextNum] = useState(0);
  const [show, setShow] = useState(showInput);

  useEffect(() => {
    setShow(showInput);
  }, [showInput])

  const onChange = (e: any) => {
    const text = e?.target?.value || '';
    setInputText(text)
    setInputTextNum(text.length);
  }

  const handleClick = () => {

    if(!user) {
      redirectLogin();
      return;
    }

    if(!inputText.trim()) {
      showToast({
        type: 'default',
        message: '请检查输入内容~'
      })
      return;
    }

    let params: ReplayPostParams = {commentId, content: inputText};

    if(type === INPUT_TYPE.REPLAY && replyId) {
      params = {...params, replyId}
    }

    REPLAY
      .post(params)
      .then((res: any) => {
        console.log('REPLAY.post res ->>', res)
        onSuccess(res.data)
        if(input.current) {
          input.current.value = '';
        }
        const message = res?.code === 0 ? '发布成功~' : res?.description;
        showToast({
          type: 'default',
          message
        })
      })
      .catch(err => {
        console.error('REPLAY.post err ->', err)
      })
  }

  const handleCancel = () => {
    setShow(false);
    if(type === INPUT_TYPE.REPLAY && onCancel) {
      onCancel()
    }
  }

  const handleInsertEmoji = (name: string) => {
    const nameLength = name.length + 2;
    if(inputTextNum +  nameLength > 200) {
      return;
    }
    const textArea = input.current;
    const emojiText = `[${name}]`;
    textArea?.focus();
    textArea?.setRangeText(emojiText, textArea?.selectionStart, textArea?.selectionEnd, "end");
    textArea?.blur();
    onChange({
      target: {
        value: input?.current?.value
      }
    })
  }

  const handleFormInputKeydown = (event: any) => {
    const textArea = input.current;
    const chatString = textArea?.value || '';

    if (event.keyCode === 8 && textArea?.selectionStart === textArea?.selectionEnd) {
        const indexEnd = (textArea?.selectionStart || 0) - 1;
        const charToDelete = chatString?.charAt(indexEnd);
        if (charToDelete === "]") {
            event.preventDefault();
            const indexStart = chatString.lastIndexOf("[", indexEnd);
            textArea?.setRangeText("", indexStart, indexEnd + 1, "end");
            onChange({
              target: {
                value: input?.current?.value
              }
            })
        }
    }
  }

  return (
    <div className={s.wrap}>
      <IfRender show={show}>
        <div className={s.inputWrap}>
          <textarea
            onChange={onChange}
            className={s.commentInput}
            placeholder='作品有哪些值得鼓励或改进的地方呢？记得保持友善、礼貌 相互鼓励，相互进步哦！～'
            maxLength={MAX_LENGTH}
            ref={input}
            onKeyDown={handleFormInputKeydown}
          />
          <div className={s.number}><span className={`${inputTextNum == 200 ? s.red : ''}`}>{inputTextNum}</span>/{MAX_LENGTH}</div>
        </div>
      </IfRender>
      <div className={s.btnWrap}>
        <IfRender show={show}>
          <>
            <span onClick={handleCancel}>取消</span>
            <YDLog click={{ name: 'click', data: { button_name: '回复' } }}>
            <span className={s.btn} onClick={handleClick}>发布</span>
            </YDLog>
          </>
        </IfRender>
        <IfRender show={!show && type === INPUT_TYPE.COMMENT}>
          <span className={s.btn} onClick={() => setShow(c => !c)}>回复评论</span>
        </IfRender>
        <div className={s.emojiWrap}><Emoji onClick={handleInsertEmoji}/></div>
      </div>
    </div>
  )
}
export default ReplayInput;
